import React from 'react'

export default function StudentList() {
  return (
    <div>StudentList</div>
  )
}
